export function getAccommodationDisplayName(accommodation, fallback) {
    var _a, _b;
    return ((_a = accommodation === null || accommodation === void 0 ? void 0 : accommodation.originalAccommodationFromProvider) === null || _a === void 0 ? void 0 : _a.trim())
        || ((_b = accommodation === null || accommodation === void 0 ? void 0 : accommodation.originalAccommodationCodeFromProvider) === null || _b === void 0 ? void 0 : _b.trim())
        || fallback || '';
}
export function getAccommodationDisplayCode(accommodation, fallbackCode, fallbackName) {
    var _a, _b;
    return ((_a = accommodation === null || accommodation === void 0 ? void 0 : accommodation.originalAccommodationCodeFromProvider) === null || _a === void 0 ? void 0 : _a.trim())
        || ((_b = accommodation === null || accommodation === void 0 ? void 0 : accommodation.originalAccommodationFromProvider) === null || _b === void 0 ? void 0 : _b.trim())
        || fallbackCode || fallbackName || '';
}
